// Short value text of a requirement for cards: comparator, value or range, unit and base for quantitative requirements, otherwise the value-type label.
import type { Requirement } from "@/api/__generated__";
import { formatValue } from "@/lib/format";
import { VALUE_TYPE_LABELS } from "@/lib/labels";

export function requirementValue(requirement: Requirement): string {
  if (requirement.value_type === "scalar" || requirement.value_type === "range") {
    const text = formatValue(requirement);
    return text === "–" ? VALUE_TYPE_LABELS[requirement.value_type] : text;
  }
  return VALUE_TYPE_LABELS[requirement.value_type];
}
